var App = App || {};

App.StructuredContent = (function ($) {
    "use strict";

    var cscImages = $(".component.component-structured-content .csc-item-image");

    function init() {
        cscImages.each(function () {
            var maxWidth = $(this).attr("data-img-width");
            if (maxWidth > 0) {
                $(this).css("margin", "auto");
                $(this).css("max-width", maxWidth + "px");
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.StructuredContent.init();
});